import React from "react";
import { Link } from "react-router-dom"; // Import Link for right-click support
import FlyGroup from '../NavBarMenu/FlyGroup';

const FlySubMenu = ({ submenus, menu_length }) => {
  return (
    <div className="submenu-panel">
      {submenus?.allmenu?.map((item) => (
        <Link 
          key={item?.ObjectType} 
          className={'submenu-item'} 
          to={item?.path}
          style={{ 
            textDecoration: 'none', 
            color: 'inherit', 
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <span className="icon drop-down-icon">
            {item?.Icon}
          </span>
          <span className='drop-down-text'>
            {item?.DiplayName}
          </span>
        </Link>
      ))}

      {Object.entries(submenus)
        .filter(([key]) => key !== "allmenu")
        .map(([groupName, items]) => (
          <FlyGroup
            key={groupName}
            groupName={groupName}
            items={items}
            icon={items[0]?.subGroupMenuIcon}
          />
        ))}
    </div>
  );
};

export default FlySubMenu;